import {Box, Typography} from '@mui/material';
import {styles} from './UserAccountSettings.styles';
import {ReactComponent as ArrowRightIcon} from '@icons/arrow-right.svg';
import {ReactComponent as ImportIcon} from '@icons/import-file.svg';
import {ReactComponent as TicketIcon} from '@icons/sidebar/ticket.svg';
import {ReactComponent as MoneyIcon} from '@icons/sidebar/money.svg';
import {ReactComponent as WarningIcon} from '@icons/danger.svg';
import {ReactComponent as ProfileIcon} from '@icons/profile.svg';
import {ReactComponent as NotificationIcon} from '@icons/notification-bell.svg';
import {ReactComponent as PaymentIcon} from '@icons/payment-method.svg';
import {ReactComponent as LockIcon} from '@icons/lock.svg';
import {useNavigate, useParams} from 'react-router-dom';
import {userStorage} from '@/utils/services';
import {useAppDispatch} from '@/store/hooks';
import Modal from '@/shared/components/Modal';
import {useState} from 'react';
import {userLogout} from '@/store/user';
import ConfirmationModal from '../Profile/General/ChangePasswordModal';
import {profileContactListStyle} from '@/pages/Organization/Profile/General/ProfileGeneral.style';
import {ProfileTabLabel} from '@/utils/enums/profile.enum';
import {setNotifications} from '@/store/notification';

const UserAccountSettings = () => {
  const {slug} = useParams();
  console.log('slug', slug);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);
  const [isShowChangePasswordModal, setIsShowChangePasswordModal] = useState(false);
  const [isShowAddPaymentMethodModal, setIsShowAddPaymentMethodModal] = useState(false);

  const handleContributionClick = () => {
    userStorage.set('activeTab', ProfileTabLabel.CONTRIBUTIONS);
    navigate(`/${slug}/profile/contributions`);
  };

  const handleProfileClick = () => {
    userStorage.set('activeTab', ProfileTabLabel.GENERAL);
    navigate(`/${slug}/profile`);
  };
  const handleNotificationClick = () => {
    userStorage.set('activeTab', ProfileTabLabel.NOTIFICATIONS);
    navigate(`/${slug}/profile/notifications`);
  };

  const handleOpenLogOutModal = () => {
    setIsLogOutModalOpen(true);
  };

  const handleChangePasswordModalChange = () => setIsShowChangePasswordModal(!isShowChangePasswordModal);
  const handleAddPaymentMethodModalChange = () => setIsShowAddPaymentMethodModal(!isShowAddPaymentMethodModal);

  const handleLogoutClick = () => {
    dispatch(userLogout());
    dispatch(setNotifications({notifications: [], target: 'unread'}));
    dispatch(setNotifications({notifications: [], target: 'all'}));
    navigate(`/${slug}` || '/');
  };

  const actionCards = [
    {id: 'profile', label: 'Profile', icon: <ProfileIcon />, action: handleProfileClick},
    {
      id: 'notifications',
      label: 'Notifications Settings',
      icon: (
        <Box>
          <NotificationIcon />
        </Box>
      ),
      action: handleNotificationClick,
    },
    {id: 'contribution', label: 'Contribution', icon: <MoneyIcon />, action: handleContributionClick},
    {id: 'payment-method', label: 'Payment Method', icon: <TicketIcon />, action: handleAddPaymentMethodModalChange},
    {id: 'change-password', label: 'Change Password', icon: <LockIcon />, action: handleChangePasswordModalChange},
    {
      id: 'log-out',
      label: 'Log Out',
      icon: (
        <Box sx={{rotate: '-90deg'}}>
          <ImportIcon />
        </Box>
      ),
      action: handleOpenLogOutModal,
    },
  ];

  return (
    <Box>
      <Box sx={styles.wrapper}>
        {actionCards.map((card) => (
          <Box key={card?.id} sx={styles.card} onClick={card?.action}>
            <Box sx={styles.textWrapper}>
              <Box sx={styles.icon}>{card?.icon}</Box>
              <Typography sx={styles.text}>{card?.label}</Typography>
            </Box>
            <Box sx={styles.arrow}>
              <ArrowRightIcon />
            </Box>
          </Box>
        ))}
      </Box>
      <Modal
        open={isLogOutModalOpen}
        onClose={() => setIsLogOutModalOpen(false)}
        onSave={handleLogoutClick}
        title="Log Out"
        description="Are you sure you want to log out?"
        closeButtonTitle="Cancel"
        mainButtonTitle="Log Out"
        mainIcon={<WarningIcon />}
        isShowCloseButton
        isShowSaveButton
        color="error"
        sx={styles.modal}
      />
      <Modal
        onClose={handleChangePasswordModalChange}
        open={isShowChangePasswordModal}
        sx={profileContactListStyle.modal}
      >
        <ConfirmationModal onCloseModal={handleChangePasswordModalChange} />
      </Modal>
      <Modal
        open={isShowAddPaymentMethodModal}
        onClose={handleAddPaymentMethodModalChange}
        title="Add Payment Method"
        description="Adding a payment method allows you to participate in the auction and make donations."
        isShowCloseButton
        closeButtonTitle="Later"
        mainButtonTitle="Add Payment Method"
        isShowSaveButton
        onSave={() => {}}
        mainIcon={<PaymentIcon />}
        sx={styles.modal}
      />
    </Box>
  );
};

export default UserAccountSettings;
